import React from 'react';
import { Outlet } from 'react-router-dom';
import { MainLayout } from './MainLayout';

export const Authlayout = () => {
  const token = localStorage.getItem('idUserToken');
  return <>{!token ? <Outlet /> : <MainLayout />}</>;
};
